import { render, staticRenderFns } from "./ConsumptionTab.vue?vue&type=template&id=ecf0dd26"
import script from "./ConsumptionTab.vue?vue&type=script&lang=ts"
export * from "./ConsumptionTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports